import { toRefs } from 'vue';

import { useAuthStore } from '@/store/authStore';
import type { Strategy } from '@/store/authStore';

export const useAuthStrategy = (): Strategy => {
  const authStore = useAuthStore();
  const { strategy } = toRefs(authStore);

  if (!strategy.value) {
    throw new Error(`Auth strategy is not defined: ${ strategy.value } `);
  }

  return strategy.value;
};
